import { Component, Inject, OnInit } from '@angular/core';
import { ComponentDetails } from '../../../../../app/modules/manage-equipment/models/manage-equipment.model';
import { ManageEquipmentService } from '../../../manage-equipment/manage-equipment.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-action-comment',
  templateUrl: './action-comment.component.html',
  styleUrls: ['./action-comment.component.scss']
})
export class ActionCommentComponent implements OnInit {
comment:string;
Component:ComponentDetails;
  constructor(public dialogRef: MatDialogRef<ActionCommentComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _manageEquipmentService: ManageEquipmentService,) { }

  ngOnInit() {
    
    this.Component=this._data.Component;
    this.comment = this.Component.ActionComment
  }
  onNoClick(){
    this.dialogRef.close(null);
  }

  save(){
    this.Component.ActionComment = this.comment;
    this.dialogRef.close(this.Component);
  }
}
